<template>
    <div>
        <div class="body-card-border-primary">
            <h3>Mi suscripción</h3>
            
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import "@/assets/style.css"

export default {
    name: "MySubscription",

    data() {
        return {
            orders : null,
        }
    },

    async created() { },

    methods: {
        ellipsis(name) {
            return name.length > 29 ? name.substring(0, 29) + "..." : name
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    },

    computed: { 
        //...mapGetters(['getCustomerData']),
    },

    watch: { 
        // dueDate(newVal) {
        //     if (newVal.length === 2 && newVal.charAt(1) !== '/') {
        //         this.dueDate = newVal + '/';
        //     }
        // }
    }
}
</script>